import { unwrap } from './client';
import api, { setTokens, clearTokens, getRefreshToken } from './client';

export function login(email, password) {
  return unwrap(api.post('/auth/login', { email, password })).then((res) => {
    if (res.data?.access_token) {
      setTokens(res.data.access_token, res.data.refresh_token);
    }
    return res;
  });
}

export function refreshSession(refreshToken) {
  return unwrap(api.post('/auth/refresh', { refresh_token: refreshToken })).then((res) => {
    if (res.data?.access_token) {
      setTokens(res.data.access_token, res.data.refresh_token);
    }
    return res;
  });
}

export function logout() {
  const refresh = getRefreshToken();
  const done = refresh
    ? unwrap(api.post('/auth/logout', { refresh_token: refresh }))
    : Promise.resolve({ data: { ok: true }, error: null });
  return done.finally(() => clearTokens());
}

/** Catalogue des rôles + capacités, en lecture (Paramètres › Utilisateur). */
export function fetchRolesCatalog() {
  return unwrap(api.get('/auth/roles'));
}

export function fetchMe(tenantId) {
  return unwrap(api.get('/auth/me', {
    params: tenantId ? { tenant_id: tenantId } : {},
  }));
}
